import { Modal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { CorrectExpenseItemAccountCodesPresenter } from '@webapp/modules/expense/features/correct-expense-item-account-codes/presenters/CorrectExpenseItemAccountCodesPresenter'
import { ApprovedExpenseItemListPresenter } from '@webapp/modules/expense/features/list-approved-expense-items/presenters/ApprovedExpenseItemListPresenter'
import messages from './messages'
import { useApprovedExpenseItemListSection } from './useApprovedExpenseItemListSection'

/**
 * Feature Set: Approved Expense Item List Section
 *
 * Orchestrates:
 * - list-approved-expense-items (always rendered)
 * - correct-expense-item-account-codes (inside the FS-owned "Edit approved
 *   item" Modal)
 * - correct-expense-item-account-code-inline (hook wired into the injected
 *   account cell)
 *
 * Self-contained — exported from the modules/expense public API (ADR-6) and
 * composed by AccountCodeCorrectionView (task 2.3) with no props.
 */
export const ApprovedExpenseItemListSection = () => {
  const intl = useProcurifyIntl()

  const {
    states: { selectedItem, isEditModalOpen },
    methods: { onEditItem, onCancel, onSuccess, renderAccountCell },
  } = useApprovedExpenseItemListSection()

  return (
    <>
      <ApprovedExpenseItemListPresenter
        onEditItem={onEditItem}
        renderAccountCell={renderAccountCell}
      />

      {/* The DS Modal has no xlg breakpoint — xl is the widest valid value
          and matches the wide Angular capture */}
      <Modal open={isEditModalOpen} onClose={onCancel} maxWidth='xl'>
        <Modal.Card>
          <Modal.Header onClose={onCancel}>
            {intl.formatMessage(messages.editModalTitle)}
          </Modal.Header>
          <Modal.Content>
            {selectedItem && (
              <CorrectExpenseItemAccountCodesPresenter
                item={selectedItem}
                onSuccess={onSuccess}
                onCancel={onCancel}
              />
            )}
          </Modal.Content>
        </Modal.Card>
      </Modal>
    </>
  )
}

ApprovedExpenseItemListSection.displayName = 'ApprovedExpenseItemListSection'
